import React, { useContext, useEffect, useRef, useState } from 'react';

import Progressbar from './Progressbar';
import './css/UserProfile.css';
import BasicInformation from './BasicInformation/BasicInformation';
import DematDetails from './DematDetails/DematDetails';
import BankDetails from './BankDetails/BankDetails';
import CreateDemat from './CreateDemat/CreateDemat';
import configData from '../../utils/config/config.json';
import { Context } from '../../services/apiContext';
import { useNotificationActionsContext } from '../../components/notificationModal/useModal';
import { useSearchParams } from 'react-router-dom';
import { getClientIp } from '../../helperFunctions/helperFunctions';
const UserProfile = (props) => {
  const nextStepRef = useRef(null);
  const setNotifi = useNotificationActionsContext();
  const contextapi = useContext(Context);
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [isRedirected, setIsRedirected] = useState(false);
  const [isCSCData, setIsCSCData] = useState(false);

  const [referrer, setReferrer] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const refid = searchParams.get('refid') || contextapi.getSession('userRefId');

  useEffect(() => {
    if (refid !== null) {
      getReferrer();
    }

    var useData = contextapi.getSession('userData');
    var userProfile = contextapi.getSession('userProfile');
    var cseData = contextapi.getSession('cseData');
    setIsCSCData(cseData ? true : false);
    console.log(useData);
    console.log(userProfile);
    console.log(props.isfromDashBoard);

    if (props.isfromDashBoard === true) {
      mapExistingData();
      setIsFirstTime(true);

      handleInputData('isTermsChecked', true);
    }
    if (props.isfromDashBoard === false && userProfile.basic_profile === 'Y') {
      mapExistingData();
      setIsFirstTime(true);
      handleInputData('isTermsChecked', true);
      console.log(basicDetails);
      if (userProfile.basic_profile === 'Y' && userProfile.dp_details === 'N') {
        setstep(2);
      } else if (
        userProfile.dp_details === 'Y' &&
        userProfile.basic_profile === 'Y'
      ) {
        setstep(3);
      }
    }

    setbasicDetails({ ...basicDetails, mobile: useData.mobile });
    if (props.isfromDashBoard === false && cseData && isFirstTime === false) {
      setbasicDetails({
        ...basicDetails,
        name: cseData.Name,
        email: cseData.EmailID,
        mobile: useData.mobile,
      });
    }
  }, []);

  const getReferrer = async () => {
    let newData = {};
    newData.Transaction_id = refid;

    var getData = {
      data: newData,
      url: configData.baseURLDev + '/logos/gettransactiondetails',
    };

    var url = configData.baseURLProxy;

    await contextapi
      .postApiAuthCalling(url, getData, false)
      .then((res) => {
        console.log(res);
        setReferrer(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [basicDetails, setbasicDetails] = useState({
    name: '',
    email: '',
    mobile: '',
    pan: '',
    upi: '',
    isTermsChecked: props.isfromDashBoard === true ? true : false,
    upiList: [],
  });
  const [dematList, setDematList] = useState({
    depositerName: '',
    dpId: '',
    clientid: '',
    dematList: [],
    dematMode: 'NSDL',
  });
  const [bankDetails, setBankDetails] = useState({
    ifsc: '',
    bankname: '',
    bankaccno: '',
    bankList: [],
  });
  const [validtityStatus, setValidtityStatus] = useState({
    step1valid: false,
    step2valid: false,
    step3valid: false,
  });
  const nextStep = () => {
    console.log(step);
    setstep(step + 1);
    console.log(step);
  };
  const mapExistingData = async () => {
    var useData = contextapi.getSession('userData').user_key;
    var postData = {
      data: {
        user_key: useData,
      },
      url: configData.baseURLDev + '/user/userprofile',
    };
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === 'sucess') {
          var depositerData = res.data[0].info[0];
          var mandates = depositerData.mandates;
          var dpclids = depositerData.pans[0].dpclids;
          var bankList = [];
          var UPIList = [];
          var dpclidsList = [];
          mandates.forEach((element) => {
            let newData = {};
            newData.ifsc = element.ifsc;
            newData.bankname = element.bankname;
            newData.bankaccno = element.bankaccno;
            newData.status =
              element.verified !== 'N' ? 'Verfied' : 'Non-Verfied';
            newData.isMasked = true;
            bankList.push(newData);
          });
          dpclids.forEach((element) => {
            let newData = {};
            newData.dpid = element.dpid;
            newData.clientid = element.clientid;
            newData.depositerName = element.dp_name;
            newData.email = element.email;
            newData.mobile = element.mobile;
            newData.src = element.source;
            newData.status =
              element.verified !== 'N' ? 'verified' : 'Non-Verfied';
            newData.isMasked = true;
            dpclidsList.push(newData);
          });
          var upiList = ['upi_id', 'upi_id2', 'upi_id3', 'upi_id4', 'upi_id5'];
          for (const iterator of upiList) {
            if (depositerData[iterator] !== '') {
              UPIList.push(depositerData[iterator]);
            }
          }
          console.log(UPIList);
          handleInputData('name', depositerData.name);
          handleInputData('isTermsChecked', true);
          handleInputData('email', depositerData.email);
          handleInputData('pan', depositerData.pan);
          handleInputData('upiList', UPIList);
          handleInputDataBank('bankList', bankList);
          handleInputDataDemat('dematList', dpclidsList);
          handleValidity('step1valid');
          handleValidity('step2valid');
          handleValidity('step3valid');
          console.log(basicDetails);
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const handleInputDataBank = (input, value) => {
    //updating for data state taking previous state and then adding new value to create new object
    setBankDetails((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };
  const handleInputData = (input, value) => {
    //updating for data state taking previous state and then adding new value to create new object
    setbasicDetails((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };
  const handleValidity = (stepNo) => {
    setValidtityStatus((prevState) => ({
      ...prevState,
      [stepNo]: true,
    }));
  };
  const handleInputDataDemat = (input, value) => {
    //updating for data state taking previous state and then adding new value to create new object
    setDematList((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };

  const GotTOCreateDmata = (stepNo, isRe) => {
    if (isRe === true) {
      setIsRedirected(true);
    }
    setstep(stepNo);
  };
  const StepClick = (stepNo) => {
    var userProfile = contextapi.getSession('userProfile');
    console.log(userProfile);
    if (stepNo === 1) {
      setstep(stepNo);
      if (
        props.isfromDashBoard === false &&
        userProfile.basic_profile === 'Y'
      ) {
        setIsFirstTime(true);
      }
    } else if (stepNo === 2) {
      if (step === 1) {
        nextStepRef.current();
      } else {
        setstep(stepNo);
      }
    } else if (stepNo === 3) {
      console.log(validtityStatus);
      if (
        validtityStatus.step1valid === true &&
        validtityStatus.step2valid === true
      ) {
        setstep(stepNo);
      }
    }
  };

  const [step, setstep] = useState(1);
  const renderUserDetails = () => {
    switch (step) {
      case 1:
        return (
          <BasicInformation
            nextStep={nextStep}
            basicDetails={basicDetails}
            handleValidity={handleValidity}
            handleFormData={handleInputData}
            isfromDashBoard={isFirstTime}
            nextStepRef={nextStepRef}
            isfromCSC={isCSCData}
          />
        );
      case 2:
        return (
          <DematDetails
            nextStep={nextStep}
            isRedirected={isRedirected}
            dematData={dematList}
            profileData={basicDetails}
            handleInputDataDemat={handleInputDataDemat}
            isfromDashBoard={props.isfromDashBoard}
            handleValidity={handleValidity}
            GotTOCreateDmata={GotTOCreateDmata}
            isfromCSC={isCSCData}
          />
        );
      case 3:
        return (
          <BankDetails
            nextStep={nextStep}
            handleValidity={handleValidity}
            handleInputDataBank={handleInputDataBank}
            isfromDashBoard={props.isfromDashBoard}
            bankDetails={bankDetails}
            dematData={dematList}
            profileData={basicDetails}
          />
        );
      case 4:
        return (
          // <CreateDemat nextStep={nextStep} prevStep={prevStep}/>
          <CreateDemat
            GotTOCreateDmata={GotTOCreateDmata}
            referrer={referrer}
            isback={true}
            isfromCSC={isCSCData}
          />
          // <UserProfileModal />
        );
    }
  };
  return (
    <>
      {step < 4 && (
        <div className='container mx-auto mt-5 px-0 leftsidebox'>
          {/* <div className="col-lg-2 col-md-3 col-sm-4 col-xs-4 col-4 paddings">
          <button
            type="button"
            className={
              btnName === "Bank Details"
                ? "customdesign w-15 activeState"
                : "customdesign w-15"
            }
            onClick={() => setbtnNameFunc("Bank Details")}
          >
            <p>Bank Details</p>{" "}
          </button>
        </div> */}

          <div className='row mx-0'>
            <div className='headerdiv'>
              <p className='userProfileHeader'>User Profile Details </p>
              <div className='progressbarinendline'>
                <Progressbar
                  bgcolor='#374488'
                  progress={step === 1 ? 40 : step === 2 ? 65 : 95}
                  height={5}
                />
              </div>
            </div>
            <div className='innerDiv'>
              <div className='row makerel'>
                <div className='col-lg-2 col-md-3 col-sm-4 col-xs-4 col-4 paddings'>
                  <button
                    type='button'
                    className={
                      step === 1
                        ? 'customdesign w-15 activeState'
                        : 'customdesign w-15'
                    }
                    onClick={() => StepClick(1)}
                  >
                    <p>Basic Information</p>{' '}
                  </button>
                </div>

                <div className='col-lg-2 col-md-3 col-sm-4 col-xs-4 col-4 paddings'>
                  <button
                    type='button'
                    className={
                      step === 2
                        ? 'customdesign w-15 activeState'
                        : 'customdesign w-15'
                    }
                    onClick={() => StepClick(2)}
                  >
                    <p>Demat Details</p>{' '}
                  </button>
                </div>

                <div className='col-lg-2 col-md-3 col-sm-4 col-xs-4 col-4 paddings'>
                  <button
                    type='button'
                    className={
                      step === 3
                        ? 'customdesign w-15 activeState'
                        : 'customdesign w-15'
                    }
                    onClick={() => StepClick(3)}
                  >
                    <p>Bank Details</p>{' '}
                  </button>
                </div>

                <div className='underline'></div>
              </div>
              <div className='col-md-12 form-divNew'>{renderUserDetails()}</div>
            </div>
          </div>
        </div>
      )}

      {step === 4 && renderUserDetails()}
    </>
  );
};

export default UserProfile;
